import { Button, Col, Row } from 'antd';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { ReactComponent as HiddenReportIcon } from 'assets/img/icons/hiddenReportIcon.svg';

const BuyReportWrapper = ({ children, handleBuyReport, type }) => {
  const { t } = useTranslation();

  return (
    <div className="buy-report-wrapper">
      <div className="buy-report-overlay">
        <Row>
          <Col xs={8} sm={8} md={8} lg={4} xl={4} xxl={3}>
            <HiddenReportIcon />
          </Col>
          {type ? (
            <>
              <Col xs={16} sm={16} md={16} lg={20} xl={20} xxl={21}>
                <Row>
                  <Col span={24} className="buy-report-overlay-title">
                    {t(`companyResult.buyReportWrapper.title.${type}`)}
                  </Col>
                  <Col span={24} className="buy-report-overlay-text">
                    {t(`companyResult.buyReportWrapper.text.${type}`)}
                  </Col>
                </Row>
              </Col>
              <Col xs={24} className="justify-content-end">
                <Button className="btn-success" onClick={handleBuyReport}>
                  {t('companyResult.buyReportWrapper.button')}
                </Button>
              </Col>
            </>
          ) : (
            <Col xs={16} sm={16} md={16} lg={18} xl={19} xxl={20} className="buy-report-overlay-title-short">
              <Trans
                i18nKey="companyResult.buyReportWrapper.title.short"
                components={{ green: <span style={{ color: 'green' }} />, buyLink: <a onClick={handleBuyReport} /> }}
              />
            </Col>
          )}
        </Row>
      </div>
      {children}
    </div>
  );
};

export default BuyReportWrapper;
